import {TeamMemberRoles} from '@discordapp/common/shared-constants/TeamMemberRoles';

import TeamMemberStore from '@developers/stores/TeamMemberStore';
import TeamStore from '@developers/stores/TeamStore';
import {getTeamIcon} from './ApplicationImageUtils';

import type {SelectOptionWithAvatar} from '@developers/components/common/AvatarSelectOption';
import type {Team, TeamId} from '@developers/flow/Server';

interface TeamOptions {
  label: string;
  value: string;
  avatar: string | null | undefined;
}

export function getTeamSelectOptions(
  teams: Map<TeamId, Team>,
  additionalTeamOptions: Array<SelectOptionWithAvatar<string>> = [],
): Array<SelectOptionWithAvatar<string>> {
  const teamOptions: TeamOptions[] = [];

  teams.forEach((team, teamId) => {
    teamOptions.push({label: team.name, value: teamId, avatar: getTeamIcon(teamId, team.icon)});
  });

  return additionalTeamOptions.concat(teamOptions);
}

export function teamMemberCan(teamId: string, userId: string, role: TeamMemberRoles, requireOwner = false) {
  const ranking = [TeamMemberRoles.ADMIN, TeamMemberRoles.DEVELOPER, TeamMemberRoles.READ_ONLY];

  if (teamId === userId) return true;

  const team = TeamStore.getTeam(teamId);
  if (team == null) return false;

  if (userId === team.owner_user_id) {
    return true;
  }

  if (requireOwner) return false;

  const member = TeamMemberStore.getTeamMembersByTeam(teamId)?.get(userId);
  if (member == null) return false;

  return ranking.indexOf(member.role) <= ranking.indexOf(role);
}
